// Accounts Module - Root Reducers
// This file aggregates all accounts-related reducers

import AccountListReducer from './List/store/slice'
import AccountFormReducer from './Form/store/slice'

// Combine all accounts reducers
const accountsReducers = {
  ...AccountListReducer,
  ...AccountFormReducer,
}

export default accountsReducers

